module.exports = __webpack_public_path__ + "static/media/eco-ecology-hand-2-svgrepo-com.d7311e02.svg";